<template>
  <v-form v-on:submit.prevent="scan(scannedInput)" ref="search-user-form" autocomplete="off" class="full-width">
    <v-text-field
      ref="scanText"
      autocomplete="off"
      :autofocus="autoFocus"
      :id="id"
      outlined
      :hint="hint"
      @focus="readyToScan = true"
      @blur="readyToScan = false"
      :rules="[readyToScan || disableScanInput ? true : 'Place cursor inside text field before scanning']"
      persistent-hint
      background-color="white"
      v-model="scannedInput"
      v-bind:value="scannedInput"
      append-icon="mdi-qrcode-scan"
      @click:append="showScannerModal"
      :label="label"
      single-line
      :disabled="scanInputLoading || disableScanInput"
      :loading="scanInputLoading"
    ></v-text-field>
  </v-form>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import SharedFunctions from '@/mixins/SharedFunctions.vue';

export default {
  mixins: [SharedFunctions],
  data() {
    return {
      //prod tests: ^^00a7cfb1-4cba-498e-8adc-509a62b7d66d^, ^^697d1bfc-1e73-4581-831d-311dc2470a7e^
      //tube code: C1990000001
      scanInputLoading: false,
      readyToScan: false,
      testTypePrefixLength: null
    };
  },
  watch: {
    caseId: {
      handler() {
        this.prefillScannedInput();
      }
    }
  },
  props: ['autoFocus', 'caseId', 'disableScanInput', 'id', 'enableMobileScanning', 'label', 'nohint', 'primarySubject', 'scannedInput'],
  mounted() {
    this.getTestTypes_();
  },
  computed: {
    hint() {
      return this.nohint ? '' : this.readyToScan ? 'Ready to Scan' : null;
    },
    testTypes_() {
      return this.testTypes;
    },
    ...mapGetters('testTypeStore', ['testTypes'])
  },
  methods: {
    async scan(input) {
      this.scanInputLoading = true;
      this.$emit('scan', input, this.scannedInput); // Implement scan in parent.
      this.scanInputLoading = false;
      this.scannedInput = null;
    },
    getTestTypes_() {
      if (this.testTypes_.length == 0) {
        this.getTestTypes();
      }
    },
    prefillScannedInput() {
      if (this.caseId != undefined) {
        this.scannedInput = '^^' + this.caseId + '^';
        this.scan(this.scannedInput);
      }
    },
    showScannerModal() {
      if (this.enableMobileScanning) {
        this.$emit('showScannerModal');
      }
    },
    ...mapActions('testTypeStore', ['getTestTypes'])
  }
};
</script>